import './CardLibrary.scss';
import { Modal } from 'react-bootstrap';
import { Button } from '@Components/Button/Button';
import { Appearance, Design } from '@Components/designConstants';
import { CardSize } from '@blisspointmedia/bpm-types/dist/dashboarding';
import { CARD_TYPES } from './dashboard-constants';
import { CardTypeValue } from './dashboard-types';

interface CardLibraryProps {
  isOpen: boolean;
  onClose: () => void;
  onAddCard: (type: CardTypeValue, size: CardSize) => void;
}

export const CardLibrary = ({ isOpen, onClose, onAddCard }: CardLibraryProps) => (
  <Modal show={isOpen} onHide={onClose} size='lg' centered>
    <Modal.Header closeButton>
      <Modal.Title>Add Card</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='card-library-grid'>
        {CARD_TYPES.map(cardType => (
          <button
            key={cardType.id}
            type='button'
            className='card-library-item'
            onClick={() => {
              onAddCard(cardType.id, cardType.defaultSize);
              onClose();
            }}
          >
            <span className='card-library-item-name'>{cardType.name}</span>
            <span className='card-library-item-size'>{cardType.defaultSize}</span>
          </button>
        ))}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button appearance={Appearance.OUTLINED} design={Design.NEUTRAL} onClick={onClose}>
        Cancel
      </Button>
    </Modal.Footer>
  </Modal>
);
